<template>
  <div>
    <loader v-if="isLoading" :loading="isLoading"/>
    <div v-else>
      <page-title title="Detalhe" :image="module.logo"/>

      <panel>
        <div class="l-row">
          <div class="l-col-3@md" v-if="feed.externalCode">
            <span>
              <strong>{{ $t('code.label') }}:</strong>
              {{ feed.externalCode }}
            </span>
          </div>

          <div class="l-col-3@md">
            <span>
              <strong>{{ $t(`${identifier}.feed.type.label`) }}:</strong>
              {{ $t(`${identifier}.feed.type.${feed.type}.label`) }}
            </span>
          </div>

          <div class="l-col-3@md">
            <span>
              <strong>{{ $t(`${identifier}.feed.created.label`) }}:</strong>
              {{ feed.created | moment('DD/MM/YYYY HH:mm') }}
            </span>
          </div>

          <div class="l-col-3@md">
            <span>
              <strong>Status:</strong>
              <span class="badge" :class="feed.status">{{ $t(`${identifier}.feed.statuses.${feed.status}.label`) }}</span>
            </span>
          </div>

          <div class="l-col-3@md">
            <span>
              <strong>Em fila:</strong>
              <span class="badge queue">{{ $t(`${identifier}.feed.queued.${feed.queued}.label`) }}</span>
            </span>
          </div>
          <div class="l-col-3@md">
            <span>
              <strong>Envio:</strong>
                <button v-if="feed.contentData" class="btnLink" @click="downloadFeed('contentData')">
                  <span class="hint hint--right" data-label="Baixe aqui">
                    Fazer download
                  </span>
                  <i class="icon-file-download"/>
                </button>
            </span>
          </div>
          <div class="l-col-3@md">
            <span>
              <strong>Retorno:</strong>
                <button v-if="feed.report" class="btnLink" @click="downloadFeed('report')">
                  <span class="hint hint--right" data-label="Baixe aqui">
                    Fazer download
                  </span>
                  <i class="icon-file-download"/>
                </button>
            </span>
          </div>
        </div>
      </panel>

      <panel title="Itens da carga" class="blue-panel" >
        <panel :title="`${item.code} - ${item.description}`" v-for="item in feed.items" :key="item" :withBody="false" :withFooter="false"/>
      </panel>
    </div>
  </div>
</template>

<script>
  import { mapFields } from 'vuex-map-fields'
  import { mapActions, mapGetters } from 'vuex'
  import PageTitle from '@/components/template/PageTitle'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'

  export default {
    props: {
      identifier: {
        type: String,
        required: true
      },
      code: {
        type: String,
        required: true
      }
    },
    methods: {
      ...mapActions('feed', [
        'addFeed'
      ]),
      downloadFeed (contentType) {
        const jsonContent = JSON.stringify(JSON.parse(this.feed[contentType]), null, 2)

        const blob = new Blob([jsonContent], { type: 'application/json' })

        const url = URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.download = `${this.feed.externalCode}_${contentType}.json`

        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      }
    },
    computed: {
      ...mapFields({
        fetching: 'feed.fetching'
      }),
      ...mapGetters('feed', [
        'getFeed'
      ]),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      module () {
        return this.getDefinitionModuleByIdentifierAndType('marketplace', this.identifier)
      },
      isLoading () {
        return this.fetching || !this.feed
      },
      feed () {
        let feed = this.getFeed(this.code)
        if (feed !== undefined) {
          return feed
        }

        this.addFeed({ identifier: this.identifier, code: this.code })
          .catch(() => {
            this.$router.push(`/marketplace/${this.identifier}/feeds`)
          })
      }
    },
    components: {
      PageTitle,
      Panel,
      Loader
    }
  }
</script>

<style lang="sass" scoped>
  strong
    display: block

  .btnLink
    background-color: transparent
    border: none
    color: #0073AA
    padding: 0
    font: inherit
    cursor: pointer
    text-decoration: none

  .btnLink:focus
    outline: none

</style>



// WEBPACK FOOTER //
// Detail.vue?eef4be22